import React, { useRef, useState } from "react";
import { useHistory } from "react-router-dom";
import { FEATURE } from "../../../consts/Common";
import {
  Button,
  Popover,
} from "@livingdesign/react";
import { User } from "@livingdesign/icons";
import { JWT } from "../../../consts/AuthFields";
import { AppState } from "../../../contexts/Core";
import { isUserAdmin } from "../../../utils/user";
import "./UserMenu.scss";

export const QA_ID_PREFIX = `UserMenu`;

function UserMenu({ user, id }) {
  const [isOpen, setIsOpen] = useState(false);
  const triggerRef = useRef(null);
  const history = useHistory();

  const isAdmin = isUserAdmin(user);

  return (
    <AppState>
      {({ isToggleEnabled }) => {
        const showDashboards =
          isToggleEnabled(FEATURE.ENTERPRISE_DASHBOARD) && isAdmin;

        return (
          <Popover
            position="bottomLeft"
            hasNubbin
            isOpen={isOpen}
            onClose={() => setIsOpen(false)}
            triggerRef={triggerRef}
            data-testid={`${QA_ID_PREFIX}-Popover`}
            content={
              <div className="user-menu-container" data-testid={`${QA_ID_PREFIX}-Container`}>
                {showDashboards && (
                  <div className="user-menu-button-list" data-testid={`${QA_ID_PREFIX}-ButtonList`}>
                    <Button
                      variant="secondary"
                      size="medium"
                      onClick={() => {
                        setIsOpen(false);
                        history.push("/admindashboard/campaignDashboard");
                      }}
                      fullWidth
                      id={`${id}-DashboardsButton`}
                      data-testid={`${QA_ID_PREFIX}-DashboardsButton`}
                      UNSAFE_className="user-menu-button"
                    >
                      Dashboards
                    </Button>
                  </div>
                )}
              </div>
            }
          >
            <div
              className={`nav-user-settings${isAdmin ? "" : " nav-user-settings--disabled"}`}
              ref={triggerRef}
              onClick={() => isAdmin && setIsOpen(!isOpen)}
              data-testid={`${QA_ID_PREFIX}-Trigger`}
              role={isAdmin ? "button" : undefined}
              tabIndex={isAdmin ? 0 : undefined}
              aria-haspopup={isAdmin ? "true" : undefined}
              aria-expanded={isAdmin ? isOpen : undefined}
              onKeyDown={isAdmin ? (e) => {
                if (e.key === "Enter" || e.key === " ") {
                  e.preventDefault();
                  setIsOpen(!isOpen);
                }
              } : undefined}
            >
              <User data-testid={`${QA_ID_PREFIX}-UserIcon`} />
              <span data-testid={`${QA_ID_PREFIX}-Greeting`}>Hi, {user?.fullname?.split(" ")[0]}</span>
            </div>
          </Popover>
        );
      }}
    </AppState>
  );
}

export default UserMenu;
